import { IntroSliceShape } from './types';

export const introCatalogTypeSelector = (state: IntroSliceShape) => state.intro.catalogType;

export const introCareerIdSelector = (state: IntroSliceShape) => state.intro.careerId;
